import { Tab, TabProps, Typography, useTheme } from '@mui/material'
import { ReactElement } from 'react'

export type TabAppProps = TabProps & {
  selectedValue: string | boolean | number
  value: string | number
  to?: string
  href?: string
  target?: string
  rel?: string
}

export function TabApp({ selectedValue, value, label, sx, ...props }: TabAppProps): ReactElement {
  const theme = useTheme()
  return (
    <Tab
      value={value}
      sx={{
        textTransform: 'none',
        opacity: 1,
        '&:hover': { bgcolor: theme.palette.primary[25] },
        ...sx
      }}
      label={
        <Typography
          variant="body1"
          sx={value === selectedValue ? { fontWeight: 700 } : {}}
          color={value === selectedValue ? 'primary' : 'grey.500'}
        >
          {label}
        </Typography>
      }
      {...props}
    />
  )
}
